import React, { useState } from 'react';
import PaginaContatti from './contatti/PaginaContatti';
import PaginaFornitori from './fornitori/PaginaFornitori';
import PaginaBrands from './brands/PaginaBrands';
import ModificaContatti from './contatti/ModificaContatti';
import ModificaBrands from './brands/ModificaBrands';
import ModificaFornitori from  './fornitori/ModificaFornitori';

function AnaLogistica({
  mobile,
  utente
}) {
  
  const [brand,setBrand] = useState(false)
  const [forn,setForn] = useState(false)
  const [cont,setCont] = useState(false)

  if (brand) {
    return(<ModificaBrands mobile={mobile} utente={utente} elemento={brand} setElemento={setBrand}/>)
  } else if (forn) {
    return(<ModificaFornitori mobile={mobile} utente={utente} elemento={forn} setElemento={setForn}/>)
  } else if (cont) {
    return(<ModificaContatti mobile={mobile} utente={utente} contatto={cont} setContatto={setCont}/>)
  } else {
    return (
      <div className='flex flex-wrap colonnaTuttaPagina-ns'>
          <div className='w-20 pa3 h-100 br b--white sfondoColChiaro'>
            <h3>BRANDS</h3>
          <PaginaBrands mobile={mobile} utente={utente} elemento={brand} setElemento={setBrand}/>
          </div>
          <div className='w-20 pa3 h-100 br b--white sfondoColChiaro'>
          <h3>FORNITORI</h3>
          <PaginaFornitori mobile={mobile} utente={utente} elemento={forn} setElemento={setForn}/>
          </div>
          <div className='w-60 pa3 h-100 sfondoColChiaro'>
          <h3>CONTATTI</h3>
          <PaginaContatti mobile={mobile} utente={utente} elemento={cont} setElemento={setCont}/>
          </div>
      </div>
    )
  }  
}

export default AnaLogistica;